import React from "react";
import ClassPrinter from "./ClassPrinter"; // Import the ClassPrinter

const ReceiptComponent = () => {
  const handlePrint = () => {
    const receiptText = getReceiptText(); // Implement this function to get the receipt text

    // Create an instance of ClassPrinter
    const printer = new ClassPrinter();

    // Call the print method to print the receipt
    printer.print(receiptText);
  };

  const getReceiptText = () => {
    // Implement this function to generate the receipt text
    // You can use your own logic to create the receipt text
    return `
      Terraweb.africa
      .....................................................................
      reciept ID:
      ---------------------------------------------------------------------
      Total: $100
      ---------------------------------------------------------------------
      Thank you for choosing Our Company, We Value You.



      
    `;
  };

  return (
    <div
      className="bg-red w-100 mt5
"
    >
      <h1>Print from here</h1>
      <button onClick={handlePrint}>Print Receipt</button>
    </div>
  );
};

export default ReceiptComponent;
